var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about_container"
  }, [_c('div', {
    staticClass: "content_wrap"
  }, [_c('div', {
    staticClass: "son-page"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu_wrap"
  }, [_c('div', {
    staticClass: "about_wrap"
  }, [_c('div', {
    class: [{
      'act-item': _vm.activeIndex == 0
    }, 'media_font_size_50'],
    on: {
      "click": function($event) {
        _vm.activeIndex = 0
      }
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    class: [{
      'act-item': _vm.activeIndex == 1
    }, 'media_font_size_50'],
    on: {
      "click": function($event) {
        _vm.activeIndex = 1
      }
    }
  }, [_vm._v("参展须知")])]), _vm._v(" "), _c('div', {
    staticClass: "right_wrap",
    style: ({
      'fontSize': '14px'
    })
  }, [_vm._v("\n        当前位置：\n        "), _c('el-breadcrumb', {
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("新闻中心")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.activeIndex == 0 ? '联系我们' : '参展须知'))])], 1)], 1)]), _vm._v(" "), (_vm.activeIndex == 0) ? _c('div', {
    staticClass: "contact_us"
  }, [_c('img', {
    attrs: {
      "src": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/about.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.activeIndex == 1) ? _c('div', {
    staticClass: "join_notice"
  }, [_c('h1', {
    staticClass: "media_font_size_70"
  }, [_vm._v("参展须知标题")]), _vm._v(" "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('page-bottom')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "about_title"
  }, [_c('span', [_vm._v("KEEP")]), _vm._v(" "), _c('span', [_vm._v("THE HEART - -")])]), _vm._v(" "), _c('h2', {
    staticClass: "media_font_size_50"
  }, [_vm._v("广州国际汽车展览会")]), _vm._v(" "), _c('span', {
    staticClass: "media_line_height_40 media_font_size_50"
  }, [_vm._v("电话：123456778990")]), _vm._v(" "), _c('span', {
    staticClass: "media_line_height_40 media_font_size_50"
  }, [_vm._v("邮箱：2222222@qq.com")]), _vm._v(" "), _c('span', {
    staticClass: "media_line_height_40 media_font_size_50"
  }, [_vm._v("地址：广州琶洲·广交会展馆")]), _vm._v(" "), _c('div', {
    staticClass: "qr_wrap"
  }, [_c('img', {
    attrs: {
      "src": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/code.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("扫一扫")]), _vm._v(" "), _c('span', [_vm._v("关注公众号")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "media_line_height_40 media_font_size_50"
  }, [_vm._v("1、参展须知说明")]), _vm._v(" "), _c('span', {
    staticClass: "media_line_height_40 media_font_size_50"
  }, [_vm._v("2、参展须知说明")]), _vm._v(" "), _c('span', {
    staticClass: "media_line_height_40 media_font_size_50"
  }, [_vm._v("3、参展须知说明")])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37675ef9","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/aboutUs/index.vue
// module id = null
// module chunks = 